import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
} from '@mui/material';

function CustomModal({
  open,
  handleClose,
  setOpen,
  title = "Título del modal",
  icon: Icon = null,
  component: Component,
  componentProps = {},
  width = '600px',
  maxHeight = '90vh',
  headerColor = 'primary',
  headerBgColor = null,
  noPadding = false,
  fullWidth = false,
  centerContent = false,
}) {
  const isMobile = useMediaQuery('(max-width:768px)');
  const theme = useTheme();
  const onClose = handleClose || (() => { try { setOpen && setOpen(false); } catch {} });

  // Obtener color del header
  const getHeaderColor = () => {
    if (headerBgColor) return headerBgColor;
    
    const colorMap = {
      primary: theme.palette.primary.main,
      success: theme.palette.success.main,
      warning: theme.palette.warning.main,
      error: theme.palette.error.main,
      info: theme.palette.info.main,
      secondary: theme.palette.secondary.main,
    };
    
    return colorMap[headerColor] || theme.palette.primary.main;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth || isMobile}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: isMobile ? '90%' : (fullWidth ? '95%' : width),
          maxHeight,
          borderRadius: 1.5,
          overflow: 'hidden',
          boxShadow: '0 3px 15px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
        },
      }}
    >
      {/* HEADER COMPACTO */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: getHeaderColor(),
          px: 2,
          py: 1.5,
          minHeight: 48,
        }}
      >
        {Icon && (
          <Icon sx={{ 
            color: 'white', 
            mr: 1.25,
            fontSize: '1.25rem',
          }} />
        )}
        <Typography
          variant="subtitle1"
          sx={{
            color: 'white',
            fontWeight: 600,
            flexGrow: 1,
            fontSize: '1.05rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
      </Box>

      <Divider sx={{ m: 0 }} />

      {/* CONTENIDO */}
      <DialogContent
        dividers
        sx={{
          flex: 1,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          ...(centerContent ? { 
            alignItems: 'center',
            justifyContent: 'center',
          } : {}),
          ...(noPadding ? { p: 0 } : { p: 2.5 }),
        }}
      >
        <Box sx={{ width: '100%' }}>
          {(() => {
            const { key: componentKey, ...restProps } = componentProps || {};
            return <Component key={componentKey} {...restProps} setOpen={setOpen} />;
          })()}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CustomModal;
